export enum ResponseStatusEnum {
    SUCCESS,
    ERROR,
    EMPTY,
}

export class ResponseStatusModel {
    resStatus: ResponseStatusEnum = ResponseStatusEnum.EMPTY;
}
